import React from 'react';
import classes from './RankingScoreCell.module.css';

const RankingScoreCell = ({ value }) => {

  const num = Number(value);
  const formattedValue = num?.toFixed(2);

  return (
    <div className={classes.rankingScoreCell}>
      {formattedValue.split('').map((char, index) => (
        <span key={index} className={classes.digit}>
          {char}
        </span>
      ))}
    </div>
  );
};

export default RankingScoreCell;
